import { EntryScore } from "./lineup";

export type Result = "win" | "loss" | "draw" | null;

/** True when every remaining player on this side is also still to play for the other side. */
const remainingPlayersShared = (mine: EntryScore, theirs: EntryScore) => {
	const mineToPlay = mine.players.filter((x) => x.active === 1 && x.currentMinutes < x.totalMinutes);
	const theirsToPlay = theirs.players.filter((x) => x.active === 1 && x.currentMinutes < x.totalMinutes);

	if (mineToPlay.length > theirsToPlay.length) {
		return false;
	}

	return mineToPlay.every((mp) => theirsToPlay.some((tp) => mp.id === tp.id));
};

export const isComplete = (side: EntryScore, opponent: EntryScore) => {
	const complete = side.gamesNotStarted === 0 && side.gamesInProgress === 0;
	return complete || remainingPlayersShared(side, opponent);
};

/**
 * Decides the result as early as the numbers allow: a finished side that is already
 * behind has lost, and shared remaining players cannot change the gap.
 */
export const decideResult = (home: EntryScore, away: EntryScore): { home: Result; away: Result } => {
	const homeTeamComplete = isComplete(home, away);
	const awayTeamComplete = isComplete(away, home);

	const homePoints = home.totalPoints;
	const awayPoints = away.totalPoints;

	if (homeTeamComplete && awayTeamComplete) {
		if (homePoints > awayPoints) {
			return { home: "win", away: "loss" };
		}
		if (awayPoints > homePoints) {
			return { home: "loss", away: "win" };
		}
		return { home: "draw", away: "draw" };
	}

	if (homeTeamComplete && homePoints < awayPoints) {
		return { home: "loss", away: "win" };
	}
	if (awayTeamComplete && awayPoints < homePoints) {
		return { home: "win", away: "loss" };
	}

	return { home: null, away: null };
};
